import React from 'react'

import {Container} from './styles'

const Wrapper = ({ children }) => {
	return <Container>{children}</Container>
}

export default Wrapper
